import {default as classNames, default as classnames} from "classnames";
import {ElementType, useContext} from "react";
import {NavLink} from "react-router";

import {Icon} from "@/components/icon/Icon.tsx";
import {NavBarContext, useIsSpecialCasePage} from "@/components/navBar/NavBar.utils.tsx";
import {NavBarChipSelector} from "@/components/navBar/subComponents/NavBarChipSelector/NavBarChipSelector.tsx";
import {NavItemProps} from "@/components/navBar/subComponents/NavBarItem/NavBarItem.types.ts";

import styles from "./NavBarItem.module.scss";

export const NavBarItem = <T extends ElementType = typeof NavLink>({
  name,
  className,
  icon,
  iconClassName,
  chip,
  as,
  visible = true,
  children,
  shouldCloseMenu = true,
  specialCasePages,
  ...rest
}: NavItemProps<T>) => {
  const {setIsMenuOpen, setIsProfileMenuOpen} = useContext(NavBarContext);
  const isSpecialCaseActive = useIsSpecialCasePage(specialCasePages);
  const Element = as || NavLink;
  const ElementProps = {
    ...rest,
    //even tho the typing of the NavBarItem will require `to` in the default case that this is a NavLink, we still need to provide a fallback so the Element doesn't complain that `to` is missing
    ...(Element === NavLink && !rest.to ? {to: "#"} : {to: rest.to}),
  };
  const onClickHandler = (e: React.MouseEvent) => {
    if (rest.onClick) {
      rest.onClick(e);
    }
    if (shouldCloseMenu) {
      setIsProfileMenuOpen(false);
      setIsMenuOpen(false);
    }
  };

  return !visible ? null : (
    <li className={classnames("d-flex")}>
      <Element
        className={classNames(
          styles.narBarItem,
          !icon && styles.navBarItemNoIcon,
          isSpecialCaseActive && "active",
          className
        )}
        data-testid={`nav${name}`}
        {...ElementProps}
        onClick={onClickHandler}
      >
        {icon && <Icon size={"navIcon"} icon={icon} className={iconClassName} />}
        <span>{name}</span>
        {chip && <NavBarChipSelector className={"ms-2"} chip={chip} />}
        {children}
      </Element>
    </li>
  );
};
